import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring';
import { handleExport } from '../Print/ExportToExcel';
import { Colors } from 'chart.js';

const SumOfReports = () => {
  const rows = [
    {
      type: 'OLD PENDING',
      academicPaid: { students: 10, amount: 10000 },
      academicUnpaid: { students: 5, amount: 5000 },
      vanPaid: { students: 1, amount: 2000 },
      vanUnpaid: { students: 2, amount: 30000 },
      totalPaid: { students: 1, amount: 500 },
      totalUnpaid: { students: 10, amount: 5000 },
    },
    {
      type: 'ADMISSION',
      academicPaid: { students: 10, amount: 10000 },
      academicUnpaid: { students: 5, amount: 5000 },
      vanPaid: { students: 1, amount: 2000 },
      vanUnpaid: { students: 2, amount: 30000 },
      totalPaid: { students: 1, amount: 500 },
      totalUnpaid: { students: 10, amount: 5000 },
    },
    {
      type: 'TERM I',
      academicPaid: { students: 10, amount: 10000 },
      academicUnpaid: { students: 5, amount: 5000 },
      vanPaid: { students: 1, amount: 2000 },
      vanUnpaid: { students: 2, amount: 30000 },
      totalPaid: { students: 1, amount: 500 },
      totalUnpaid: { students: 10, amount: 5000 },
    },
    {
      type: 'TERM II',
      academicPaid: { students: 10, amount: 10000 },
      academicUnpaid: { students: 5, amount: 5000 },
      vanPaid: { students: 1, amount: 2000 },
      vanUnpaid: { students: 2, amount: 30000 },
      totalPaid: { students: 1, amount: 500 },
      totalUnpaid: { students: 10, amount: 5000 },
    },
    {
      type: 'TERM III',
      academicPaid: { students: 10, amount: 10000 },
      academicUnpaid: { students: 5, amount: 5000 },
      vanPaid: { students: 1, amount: 2000 },
      vanUnpaid: { students: 2, amount: 30000 },
      totalPaid: { students: 1, amount: 500 },
      totalUnpaid: { students: 10, amount: 5000 },
    },
  ];

  const tableRef = useRef(null);

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);
  
    const [formData, setFormData] = useState({ ADDFEES: '' });

  useEffect(() => {
   
     // fetchData();
   
  }, [])

    const fetchData = async () => {
    try {
      const response = await axios.get(AppStrings.SummaryReport + `?TYPE=${formData.ADDFEES}`);
      const result = response.data.data;
      console.log(result[0])
      if (Array.isArray(result)) {
        setReport(result);
        setError('');
      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  
    const exportExcel = () => {
      handleExport(tableRef.current, 'excel', 'StudentSummarysReport');
    };
  
    const exportPDF = () => {
      handleExport(tableRef.current, 'pdf', 'StudentSummarysReport');
    };


    const now = new Date();
const currentDate = now.toLocaleDateString(); // e.g., "8/11/2025"
const currentTime = now.toLocaleTimeString([], {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: true,
});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
    <div className="row">
        <div className="col-25">
             <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label htmlFor="input" className="text">Student Type</label>
            <select
              name="ADDFEES"
              value={formData.ADDFEES}
              onChange={handleChange}
              className="input"
            >
              <option value="">SELECT</option>
              <option value="MET">MATRIC</option>
              <option value="CBSE">CBSE</option>
            </select>
            </div></div>
             <div className="col-25">
         
           <button style={{...ExportBtn, marginTop: '15px' }} onClick={fetchData}><span>View</span></button>
            </div>
          </div>
        </div>
         
      </div>
    <button style={ExportBtn} onClick={exportExcel}>Export to Excel</button>
      <button style={ExportBtn} onClick={exportPDF}>Export to PDF</button>
    <table ref={tableRef} style={tableStyle}>
      <thead>
         <tr>
          <th style={{ ...headerStyle }} colSpan="15">{formData.ADDFEES} Summary Report Date : {currentDate} {currentTime}</th>
        </tr>
        <tr>
          <th style={{ ...headerStyle }} rowSpan="3">Type</th>
          <th style={headerStyle} colSpan="4">Academic Fees</th>
          <th style={headerStyle} colSpan="4">Van Fees</th>
          <th style={headerStyle} colSpan="4">Total</th>
        </tr>
        <tr>
          <th style={headerStyle} colSpan="2">Paid</th>
          <th style={headerStyle} colSpan="2">Un Paid</th>
          <th style={headerStyle} colSpan="2">Paid</th>
          <th style={headerStyle} colSpan="2">Un Paid</th>
          <th style={headerStyle} colSpan="2">Paid</th>
          <th style={headerStyle} colSpan="2">Un Paid</th>
        </tr>
        <tr>
          <th style={headerStyle}>No. Student</th><th style={headerStyle}>Amount</th>
          <th style={headerStyle}>No. Student</th><th style={headerStyle}>Amount</th>
          <th style={headerStyle}>No. Student</th><th style={headerStyle}>Amount</th>
          <th style={headerStyle}>No. Student</th><th style={headerStyle}>Amount</th>
          <th style={headerStyle}>No. Student</th><th style={headerStyle}>Amount</th>
          <th style={headerStyle}>No. Student</th><th style={headerStyle}>Amount</th>
        </tr>
      </thead>
     <tbody>
  {Array.isArray(report) && report.length > 0 ? (
    report.map((row, index) => {
      const isLastRow = index === report.length - 1;
      return (
        <tr key={index} style={isLastRow ? lastRowStyle : RowStyle}>
          <td style={cellStyle}>{row.TYPE}</td>
          <td style={cellStyle}>{row.NO_OF_STUDENTS_PAID}</td>
          <td style={cellStyle}>{row.PAID}</td>
          <td style={cellStyle}>{row.NO_OF_STUDENTS_UNPAID}</td>
          <td style={cellStyle}>{row.UNPAID}</td>
          <td style={cellStyle}>{row.NO_OF_STUDENTS_BUS_PAID}</td>
          <td style={cellStyle}>{row.BUS_PAID}</td>
          <td style={cellStyle}>{row.NO_OF_STUDENTS_BUS_UNPAID}</td>
          <td style={cellStyle}>{row.BUS_UNPAID}</td>
          <td style={cellStyle}>{row.NO_OF_STUDENTS_TOTAL_PAID}</td>
          <td style={cellStyle}>{row.TOTAL_PAID}</td>
          <td style={cellStyle}>{row.NO_OF_STUDENTS_TOTAL_UNPAID}</td>
          <td style={cellStyle}>{row.TOTAL_UNPAID}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="13" style={cellStyle}>
        {loading ? 'Loading...' : 'No data available'}
      </td>
    </tr>
  )}
</tbody>
    </table>
    </>
  );
};

const ViewBtn={
    //width:'100px',height:'30px'
}
const lastRowStyle = {
    backgroundColor: '#f1d3e0ff',
    fontWeight:'bold',
    color:'#3412afff',
  };
  const RowStyle = {
    backgroundColor: '#ffffffff',
    
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'center',
    borderRadius: '10px',
  };

  const cellStyle = {
    border: '1px solid #ffffffff',
    padding: '8px',
    //backgroundColor:'#b3e3f0ff'
  };

  const headerStyle = {
    ...cellStyle,
    backgroundColor: '#cfe9f0ff',
    fontWeight: 'bold',
  };
  const   ExportBtn= {
    fontSize: '12px',
    marginRight: '10px',
    marginBottom: '10px',
  };


export default SumOfReports;
